import { render } from "./CoursesList.vue?vue&type=template&id=dbe24a98&scoped=true"
import script from "./CoursesList.vue?vue&type=script&lang=js"
export * from "./CoursesList.vue?vue&type=script&lang=js"

import "./CoursesList.vue?vue&type=style&index=0&id=dbe24a98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbe24a98"]])

export default __exports__